import {} from "@fortawesome/fontawesome-svg-core";
import {} from "@/components/Common/models/exportRecordModel";
import { BIO_COMPUTE_OBJ_EXPORT_PLUGIN } from "./BioComputeObject/BioComputeObjectExportPlugin";
import { DEFAULT_FILE_EXPORT_PLUGIN } from "./DefaultFileExportPlugin";
import { RO_CRATE_EXPORT_PLUGIN } from "./ROCrateExportPlugin";
export const AVAILABLE_INVOCATION_EXPORT_PLUGINS = new Map([
    ["ro-crate", RO_CRATE_EXPORT_PLUGIN],
    ["bco", BIO_COMPUTE_OBJ_EXPORT_PLUGIN],
    ["default-file", DEFAULT_FILE_EXPORT_PLUGIN],
]);
export function getInvocationExportPluginByType(pluginType) {
    const plugin = AVAILABLE_INVOCATION_EXPORT_PLUGINS.get(pluginType);
    if (!plugin) {
        throw new Error("Unregistered Invocation Export Plugin. Please register it first.");
    }
    return plugin;
}
